/**
 * DisconnectDialog — the "Trennen" confirm (Story MC6 AC5).
 *
 * Names the mailbox, then confirms → `DELETE /mailbox/connections/:id`. Destructive
 * framing (not Primary blue). The caller owns the mutation + toasts; this is a
 * pure confirm shell over the admin `Dialog` primitive.
 *
 * [Source: apps/web/src/features/administration/components.tsx (Dialog)]
 */

import { Dialog, Button } from '../../administration/components';
import type { MailboxConnectionDto } from '../types';

export function DisconnectDialog({
  connection,
  pending,
  onConfirm,
  onClose,
}: {
  /** The mailbox being disconnected, or null when the dialog is closed. */
  connection: MailboxConnectionDto | null;
  pending: boolean;
  onConfirm: (connection: MailboxConnectionDto) => void;
  onClose: () => void;
}) {
  return (
    <Dialog
      open={connection != null}
      onClose={onClose}
      title="Postfach trennen"
      description={
        connection != null
          ? `Die Verbindung zu ${connection.email} wird entfernt. Eingehende Nachrichten aus diesem Postfach werden nicht mehr synchronisiert.`
          : undefined
      }
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={pending}>
            Abbrechen
          </Button>
          <Button
            variant="destructive"
            disabled={pending || connection == null}
            onClick={() => connection != null && onConfirm(connection)}
          >
            Trennen
          </Button>
        </>
      }
    >
      <p className="text-sm text-muted-foreground">
        Du kannst das Postfach jederzeit erneut verbinden.
      </p>
    </Dialog>
  );
}
